import ForestryIcon from "~/components/icons/Forestry.vue";
import UrbanForestryIcon from "~/components/icons/UrbanForestry.vue";

const colors = __NUXT__.config.COLORS; // eslint-disable-line

export default {
  theme: {
    themes: {
      light: {
        primary: colors.primary,
        accent: colors.accent,
        secondary: colors.secondary,
        success: "#83BE81",
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    values: {
      forestry: {
        component: ForestryIcon,
      },
      urbanForestry: {
        component: UrbanForestryIcon,
      },
    },
  },
};
